import {z} from 'zod'

export const MessageTemplateChannelSchema = z.enum(['WHATSAPP', 'EMAIL'])
export type MessageTemplateChannel = z.infer<typeof MessageTemplateChannelSchema>

export const CreateMessageTemplateRequestSchema = z.object({
  name: z.string().max(100),
  scope: z.string(),
  status: z.string(),
  message: z.string(),
  active: z.boolean(),
  channel: MessageTemplateChannelSchema,
})
export type CreateMessageTemplateRequest = z.infer<typeof CreateMessageTemplateRequestSchema>

export const CreateMessageTemplateResponseSchema = z.object({
  id: z.number(),
  name: z.string().max(100),
  scope: z.string().nullish(),
  status: z.string().nullish(),
  message: z.string().nullish(),
  updated_on: z.string().nullish(),
  created_by: z.string().nullish(),
  active: z.boolean().nullish(),
})
export type CreateMessageTemplateResponse = z.infer<typeof CreateMessageTemplateResponseSchema>
